import { Success, Failure, PromiseResult } from 'libs/apis/errors/Result';
import { AppError } from 'libs/apis/errors/AppError';
import type { ApiErrorResponse } from 'libs/apis/generated/models/ApiErrorResponse';
import type { PostCartItemForm } from 'libs/apis/generated/models/PostCartItemForm';
import type { ResultOkResponse } from 'libs/apis/generated/models/ResultOkResponse';
import { addCart } from 'libs/apis';

export type AddCartProductOptionParams = {
  optionId: number;
  unitIds?: number[];
  unitId?: number;
};

export type AddCartProductParams = {
  productId: number;
  preferEGift?: boolean;
  options?: AddCartProductOptionParams[];
};

type PostCartItemRequestBody = PostCartItemForm & {
  preferEGift?: boolean;
};

type ApiErrorLike = {
  body?: Partial<ApiErrorResponse>;
};

const resolveErrorMessage = (error: unknown): string => {
  const responseMessage = (error as ApiErrorLike).body?.message;
  if (typeof responseMessage === 'string' && responseMessage.length > 0) {
    return responseMessage;
  }

  return error instanceof Error ? error.message : 'カートへの追加に失敗しました。';
};

export const addCartProduct = (params: AddCartProductParams): PromiseResult<ResultOkResponse, AppError> =>
  (async () => {
    try {
      const requestBody: PostCartItemRequestBody = {
        productId: params.productId,
        preferEGift: params.preferEGift,
        options: params.options,
      };
      const response = await addCart(requestBody);
      return new Success(response);
    } catch (error) {
      return new Failure(new AppError(resolveErrorMessage(error)));
    }
  })();
